// Copyright (c) 2022 by Move Closer

import { PropType } from '@vue/composition-api'

import { ComponentObjectPropsOptions } from '../../vue-api'

import { NavProps } from './Nav.contracts'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const navProps: ComponentObjectPropsOptions<NavProps> = {
  /**
   * Items to render.
   */
  links: {
    type: Array as PropType<NavProps['links']>,
    required: true
  },
  navListContainerClasses: {
    type: Array as PropType<NavProps['navListContainerClasses']>,
    required: false,
    default: () => ['container']
  }
}
